module.exports = __webpack_public_path__ + "static/media/map.5c5b50bf.svg";